var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFormCheckboxUnselected = function SvgIconsFormCheckboxUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 4c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h12zm0 1.7H6c-.142 0-.261.099-.292.231L5.7 6v12c0 .142.099.261.231.292L6 18.3h12c.142 0 .261-.099.292-.231L18.3 18V6c0-.142-.099-.261-.231-.292L18 5.7z"
  })));
};
export default SvgIconsFormCheckboxUnselected;